export default __webpack_public_path__ + "static/media/categories.33ae46e8.svg";